import { isObject } from '@kk/shared/utils/type-guards';

export type RequestOpts = Omit<RequestInit, 'body' | 'headers'> & {
  priority?: 'high' | 'low';
};

export type ErrorResponse<TData = { message?: string }> = Omit<
  Response,
  'text'
> & {
  data?: TData;
  text?: () => Promise<string>;
};

export function isErrorResponse<TData = { message?: string }>(
  response: unknown,
): response is ErrorResponse<TData> {
  return (
    isObject(response) && 'status' in response && 'headers' in response
    // && 'text' in response
  );
}
